var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCircleCheckCircleDarkFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.623 21.246a10.624 10.624 0 110-21.248 10.624 10.624 0 010 21.248zM16.52 8.17l-1.362-1.34L8.842 13l-2.745-2.682-1.372 1.341 4.106 4.023 7.69-7.512z",
    fill: "#000"
  })));
}

export default __webpack_public_path__ + "media/images/styleguide/icons/icon-circle--check-circle-dark-fill-aa0c74c1601626d70120feb3011fea5d.svg";
export { SvgIconCircleCheckCircleDarkFill as Component };